import {EntegratorConf, VirtualHost} from "../constants";
import {EntegratorIdentifiers} from "./enums";
import moment from "moment";

export function showSmmRepeatDay(documentType) {
    return ["SMM", "SERBESTMESLEKMAKBUZ"].includes(documentType) &&
        ["devatek","smart","kolaysoft","ankarabarosu", "hataybarosu", "afyonbarosu", "nevsehirbarosu", "zonguldakbarosu", "musavir", "avukat", "esmm", "turcef", "valoremteam", "tdub", "hizli", "datakontrol", "mbtfatura", "zirve"].includes(VirtualHost.conf.resourcePrefix);
}

export function showBaro() {
    return ["ankarabarosu", "hataybarosu", "afyonbarosu", "nevsehirbarosu", "zonguldakbarosu", "musavir", "avukat", "esmm", "turcef"].includes(VirtualHost.conf.resourcePrefix);
}

export function showKalanBaro() {
    return ["musavir"].includes(VirtualHost.conf.resourcePrefix);
}

export function showConnector(entIdentifier) {
    return [
        EntegratorIdentifiers.KOLAYSOFT,
        EntegratorIdentifiers.SMART,
        EntegratorIdentifiers.UNIVERA,
        EntegratorIdentifiers.MBT,
        EntegratorIdentifiers.ZIRVE,
        EntegratorIdentifiers.BYM,
        EntegratorIdentifiers.AKTIF
    ].includes(entIdentifier)
}

export function showRedirectPortal(entIdentifier) {
    return false;
    //return [EntegratorIdentifiers.SMART].includes(entIdentifier)
}

export function showDenizButikConnector(entIdentifier, currentUserIdentifier) {
    return[EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT].includes(entIdentifier) &&
        ('2911416516' === currentUserIdentifier);
}

export function showExternalPayment(identifier, currentUser) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(identifier) &&
        (currentUser.accountant || currentUser.isDistributor);
}

export function showPriceListModal(identifier, currentUser) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(identifier) &&
        (currentUser.isDistributor && currentUser.workType===3) && currentUser.parentCustomerId === 1;
}

export function showOnlyZirve() {
    return false;
    //const list = ["zirve"];
    //return list.includes(VirtualHost.conf.resourcePrefix);
}

export function showBaroLoginPage() {
    const list = ["valoremteam", "medikal", "tdub", "isitmemerkezi", "testud", "vega", "cicekfatura", "masfed", "temfed","esnaffatura", "turofed","avho", "mbtfatura", "veteriner", "allesfaturam","sigortafatura"];
    return showBaro() || list.includes(VirtualHost.conf.resourcePrefix);
}

export function showFaturam24LoginPage() {
    const list = ["faturam24"];
    return list.includes(VirtualHost.conf.resourcePrefix);
}

export function showCancelLetter(parentCustomerId) {
    const prefix = {
        //prefix:[parentCustomerId]
        'medikal': [10941],
        'isitmemerkezi': [12359],
        'eczacikart': [5925, 15829, 16103,46486,28839,30735],
        'testud': [12584],
        'togb': [6951]
    }

    return prefix[VirtualHost.conf.resourcePrefix] &&
        ((prefix[VirtualHost.conf.resourcePrefix].length && prefix[VirtualHost.conf.resourcePrefix].length === 1 && prefix[VirtualHost.conf.resourcePrefix][0] === "*")
            || prefix[VirtualHost.conf.resourcePrefix].includes(parentCustomerId));
}

export function show100000AsUnlimited(parentCustomerId) {
    const prefix = {
        "ankarabarosu": ["*"],
        "hataybarosu": ["*"],
        "afyonbarosu": ["*"],
        "nevsehirbarosu": ["*"],
        "zonguldakbarosu" : ["*"],
        "avukat": ["*"],
        "esmm": ["*"],
        "turcef": ["*"],
        "tdub": ["*"],
        "isitmemerkezi": ["*"],
        "medikal": ["*"],
        "testud": ["*"],
        "smart":[5403,3248],
        "eczacikart":[46486],
        "uludagbilisim":[3312],
        "faturam24": [59409]
    };

    return  prefix[VirtualHost.conf.resourcePrefix] &&
        ((prefix[VirtualHost.conf.resourcePrefix].length && prefix[VirtualHost.conf.resourcePrefix].length === 1 && prefix[VirtualHost.conf.resourcePrefix][0] === "*")
            || prefix[VirtualHost.conf.resourcePrefix].includes(parentCustomerId));
}

export function showCalculateVoucherBtn() {
    return ["smart", "kolaysoft", "ankarabarosu", "hataybarosu", "afyonbarosu", "nevsehirbarosu", "zonguldakbarosu", "avukat", "musavir", "esmm", "turcef", "valoremteam", "tdub", "datakontrol", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
}
export function showMediaIcons() {
    return ["eczacikart", "kolaysoft", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
}

export function showBarStandartVouchers() {
    return ["smart", "kolaysoft", "ankarabarosu", "hataybarosu", "afyonbarosu", "nevsehirbarosu", "zonguldakbarosu", "avukat", "valoremteam", "tdub", "datakontrol", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
}

export function showContactCard() {
    return ["faturam24","kolaysoft", "ankarabarosu", "hataybarosu", "afyonbarosu", "nevsehirbarosu", "zonguldakbarosu", "avukat", "eczacikart", "togb",
        "smart", "tdub", "musavir", "esmm", "turcef", "medikal", "isitmemerkezi", "testud", "ustunbilgisayar", "masfed", "temfed", "mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
}

export function disAllowChooseContractType(entegratorIdentifier, customerId, isAdmin) {
    let smartList = [404,4861,4862,4863,4864,4865,4867]; /* test sonrası canlıdan önce gelen customerId listesi eklenecek*/
    //let kolaysoftList = ["customerIdListesiEklenecek"];

    if (EntegratorIdentifiers.SMART === entegratorIdentifier){
        if(isAdmin)
            return !(smartList.includes(customerId))
        else
            return true
    }
    return [EntegratorIdentifiers.MBT].includes(entegratorIdentifier);
}

export function hiddenButton(isEntegrator, entegratorIdentifier, customerId) {
    let smartList = [404, 4861, 4862, 4863, 6864, 6865, 6867];
    if ((!isEntegrator && EntegratorIdentifiers.KOLAYSOFT === entegratorIdentifier) || (!isEntegrator && EntegratorIdentifiers.MBT === entegratorIdentifier)) {
        return false;
    } else if (!isEntegrator && EntegratorIdentifiers.SMART === entegratorIdentifier && !smartList.includes(customerId)) {
        return false;
    } else {
        return true;
    }
}

export function showPaytrButton(parentCustomerWorkType,entIdentifier) {
    return ([EntegratorIdentifiers.KOLAYSOFT,
             EntegratorIdentifiers.SMART,
             EntegratorIdentifiers.MBT,
             EntegratorIdentifiers.BYM,
             EntegratorIdentifiers.AKTIF,
    ].includes(entIdentifier) && parentCustomerWorkType && parentCustomerWorkType === 1);
}

export function showAnnouncement() {
    let list = [
        // "kolaysoft",
        // "titck",
        // "haser",
        // "eczacikart",
        // "togb",
        // "ankarabarosu",
        // "afyonbarosu",
        // "avukat",
        // "musavir",
        // "hataybarosu",
        // "nevsehirbarosu",
        // "zonguldakbarosu",
        // "esmm",
        // "interpos",
        // "laglobal",
        // "datakontrol",
        "netkasam"
        // "jetteknoloji",
        // "halsistem",
        // "daraplus",
        // "quantumyazilim",
        // "epusula",
        // "eris",
        // "mostidea",
        // "cizgiyazilim",
        // "imabilisim",
        // "nfdyazilim",
        // "smart",
        // "turcef",
        // "valoremteam",
        // "medikal",
        // "isitmemerkezi",
        // "testud",
        // "zirve",
        // "vega",
        // "univera",
        // "mikrokom",
        // "hizli",
        // "farmakom",
        // "devatek",
        // "medi",
        // 'cicekfatura',
        // 'mbtfatura'
    ];
    return !list.includes(VirtualHost.conf.resourcePrefix);
}

export function showDistributorContract() {
    return ["smart","kolaysoft","halsistem","mbtfatura","bymfatura","aktifdonusum"].includes(VirtualHost.conf.resourcePrefix);
}

export function showEdefterBildirimDocumentStatusInfo(entIdentifier) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(entIdentifier)
}

export function showCustomerAnnouncement() {
    return ["smart","kolaysoft","mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
}

export function showEdefterDocumentStatusInfo(entIdentifier) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.HIZLI, EntegratorIdentifiers.DEVATEK, EntegratorIdentifiers.MBT].includes(entIdentifier)
}

export function showProgressPayment(customerId){
    let showList = {
        'smart': [1, 4342],
        'kolaysoft': [1],
        'halsistem': [404, 4861, 4862, 4863, 4864, 4865, 4867],
        'mbtfatura': [1],
        'bymfatura':[1],
        'aktifdonusum':[1],
    };

    return showDistributorContract() && (showList[VirtualHost.conf.resourcePrefix] && showList[VirtualHost.conf.resourcePrefix].includes(customerId));
}

export function showProgressPaymentFields(customerId){
    let showList = {
        'smart':[1,4342],
        'kolaysoft':[1],
        'mbtfatura':[1],
        'halsistem':[404],
        'bymfatura':[1],
        'aktifdonusum':[1]
    };

    return showDistributorContract() && showProgressPayment(customerId) && (showList[VirtualHost.conf.resourcePrefix] && showList[VirtualHost.conf.resourcePrefix].includes(customerId));
}

export function showDbs() {
    const list = ["valoremteam", "tdub", "smart", "kolaysoft", "datakontrol", "faturam24", "mbtfatura", "esnaffatura"];
    return showBaro() || list.includes(VirtualHost.conf.resourcePrefix);
}

export function showPredefinedBtn() {
    return ["smart", "kolaysoft", "aryabilisim", "cicekfatura","esnaffatura","masfed","temfed", 'mbtfatura'].includes(VirtualHost.conf.resourcePrefix);
}

export function showPredefinedBtn24(entegratorIdentifier) {
    return [EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(entegratorIdentifier)
    // return ["smart", "kolaysoft", "faturam24"].includes(VirtualHost.conf.resourcePrefix);
}

export function showEdefterApplicationCard(entegratorIdentifier) {
    let now = new Date();
    let firstDate = new Date(now.getFullYear(), 11, 31);
    let secondDate = new Date(now.getFullYear() + 1, 0, 31);
    return firstDate <= now && secondDate >= now
        && [EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(entegratorIdentifier)
        && VirtualHost.conf.resourcePrefix !== "cicekfatura";
}

export function showInvoiceTotalFilter(){
    return ["eczacikart"].includes(VirtualHost.conf.resourcePrefix);
}

export function showEdefterSecondCopyApplicationCard(entegratorIdentifier, parentCustomerId) {
    let smartList = [395, 2642];
    let kolaysoftList = [3956];
    return (EntegratorIdentifiers.SMART === entegratorIdentifier && !smartList.includes(parentCustomerId))
        || (EntegratorIdentifiers.KOLAYSOFT === entegratorIdentifier && !kolaysoftList.includes(parentCustomerId))
        || (EntegratorIdentifiers.MBT === entegratorIdentifier);
}

export function showDateFilter(identifier){
    let enableList = [
        EntegratorIdentifiers.DEVATEK,
        EntegratorIdentifiers.FARMAKOM,
        EntegratorIdentifiers.HIZLI,
        EntegratorIdentifiers.UNIVERA,
        EntegratorIdentifiers.MIKROKOM,
        EntegratorIdentifiers.SMART,
        EntegratorIdentifiers.MEDIFATURA,
        EntegratorIdentifiers.VEGA,
        EntegratorIdentifiers.ZIRVE,
        EntegratorIdentifiers.KOLAYSOFT,
        EntegratorIdentifiers.MBT,
        EntegratorIdentifiers.BYM,
        EntegratorIdentifiers.AKTIF,
    ];
    return enableList.includes(identifier);
}

export function showUts(parentCustomerId) {
    const prefix = {
        //prefix:[parentCustomerId]
        'medikal': [10941],
        'isitmemerkezi': [12359],
        'hizli': ["*"],
        'togb': [6951]
    }

    return prefix[VirtualHost.conf.resourcePrefix] &&
        ((prefix[VirtualHost.conf.resourcePrefix].length && prefix[VirtualHost.conf.resourcePrefix].length === 1 && prefix[VirtualHost.conf.resourcePrefix][0] === "*")
            || prefix[VirtualHost.conf.resourcePrefix].includes(parentCustomerId));
}

export function showSidebarSgkFaturalar(){
    return !(["eczacikart", "togb", "isitmemerkezi", "testud"].includes(VirtualHost.conf.resourcePrefix));
}

export function showSgkInvoiceInfo(){
    return (["eczacikart", "togb", "kolaysoft"].includes(VirtualHost.conf.resourcePrefix));
}

export function showRetailCustomerVknTcknManuelInput(entegratorIdentifiers) {
    return [EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(entegratorIdentifiers);
}

export function showFastExternalCustomer(identifier) {
    return [EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(identifier);
}

export function showSmmInformationModal(parentCustomerId) {
    const prefix = {
        //prefix:[parentCustomerId]
        'eczacikart': [46486, 30735, 15829, 5925, 28839],
        'togb': [6951],
        'medikal': [10941],
        'isitmemerkezi': [12359],
        'testud': [6951],
        'smart': [1, 3836],
        'mbtfatura': [1]
    }

    return showBaro() || (prefix[VirtualHost.conf.resourcePrefix] &&
        ((prefix[VirtualHost.conf.resourcePrefix].length && prefix[VirtualHost.conf.resourcePrefix].length === 1 && prefix[VirtualHost.conf.resourcePrefix][0] === "*")
            || prefix[VirtualHost.conf.resourcePrefix].includes(parentCustomerId)));
}

export function showExcelExport(entegratorIdentifier) {
   return [EntegratorIdentifiers.UNIVERA,
        EntegratorIdentifiers.MIKROKOM,
        EntegratorIdentifiers.DEVATEK,
        EntegratorIdentifiers.FARMAKOM,
        EntegratorIdentifiers.SMART,
        EntegratorIdentifiers.HIZLI,
        EntegratorIdentifiers.VEGA,
        EntegratorIdentifiers.ZIRVE,
        EntegratorIdentifiers.KOLAYSOFT,
        EntegratorIdentifiers.TURKKEP,
        EntegratorIdentifiers.BYM,
        EntegratorIdentifiers.AKTIF
   ].includes(entegratorIdentifier)
}

export function showTotalData(entegratorIdentifier) {
    return [EntegratorIdentifiers.SMART,
            EntegratorIdentifiers.KOLAYSOFT,
            EntegratorIdentifiers.MBT,
            EntegratorIdentifiers.BYM,
            EntegratorIdentifiers.AKTIF].includes(entegratorIdentifier);
}

export function showOwnInbox(entegratorIdentifier,currentUser) {
   return false;
    // return ("" === currentUser.vknTckn && [EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(entegratorIdentifier));
}

export function showCreditEdit(entegratorIdentifier) {
    return !([EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(entegratorIdentifier));
}

export function showTurmob(entegratorIdentifier) {
    return [EntegratorIdentifiers.SMART,
        EntegratorIdentifiers.KOLAYSOFT,
        EntegratorIdentifiers.MIKROKOM,
        EntegratorIdentifiers.DEVATEK,
        EntegratorIdentifiers.MBT,
        EntegratorIdentifiers.BYM].includes(entegratorIdentifier);
}

export function showEarsivInbox(entegratorIdentifier) {
    return [EntegratorIdentifiers.SMART,
        EntegratorIdentifiers.KOLAYSOFT,
        EntegratorIdentifiers.UNIVERA,
        EntegratorIdentifiers.MBT,
        EntegratorIdentifiers.MIKROKOM].includes(entegratorIdentifier);
}

export function showDistributorAllowCreditChange(isEntegrator, entegratorIdentifier) {
    return !(!isEntegrator && [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(entegratorIdentifier));
}

export function showLuca(entegratorIdentifiers) {
    return [EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.MBT].includes(entegratorIdentifiers);
}

export function showKonaklamaVergisiButton(entegratorIdentifier)
{
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(entegratorIdentifier);
}

export function showKolaySmartMbt(entegratorIdentifier)
{
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(entegratorIdentifier);
}

export function showKolayAndSmart(entegratorIdentifier)
{
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(entegratorIdentifier);
}

export function showChemistInformationModal() {
    return ["eczacikart"].includes(VirtualHost.conf.resourcePrefix);
    // return ["kolaysoft", "eczacikart"].includes(VirtualHost.conf.resourcePrefix) &&
    //     [28839, 30735, 15829, 5925].includes(currentUser.parentCustomerId);
}

export function isVakifbankUser(parentCustomerId, entegratorIdentifiers) {
    return ((parentCustomerId === 415 || parentCustomerId === 15795) && [EntegratorIdentifiers.KOLAYSOFT].includes(entegratorIdentifiers))
}

export function isVakifbank() {
    return VirtualHost.conf.resourcePrefix === "vakifbank";
}

export function checkNavlun(deliveryTerms) {
    return (deliveryTerms === "CIF" ||
        deliveryTerms === "CFR" ||
        deliveryTerms === "DAP" ||
        deliveryTerms === 'CPT' ||
        deliveryTerms === 'CIP');
}

export function showConnectorPayment(identifier) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART].includes(identifier);
}

export function showConnectorPaymentKolay(identifier) {
    return [EntegratorIdentifiers.KOLAYSOFT].includes(identifier);
}

export function showPaymentInfo(){
    return ["smart","kolaysoft","mbtfatura"].includes(VirtualHost.conf.resourcePrefix);
}

export function chooseFromList(isEntegrator,identifier) {
    return ([EntegratorIdentifiers.KOLAYSOFT,
             EntegratorIdentifiers.SMART,
             EntegratorIdentifiers.MBT]
            .includes(identifier) ? isEntegrator : true);
}

export function checkMonthBased(identifier, year) {
    if([EntegratorIdentifiers.KOLAYSOFT,
        EntegratorIdentifiers.SMART,
        EntegratorIdentifiers.ZIRVE,
        EntegratorIdentifiers.UNIVERA,
        EntegratorIdentifiers.MIKROKOM,
        EntegratorIdentifiers.FARMAKOM
    ].includes(identifier)) {
        let now = moment();
        if(year === now.year() && (now.month()+1) > 6){
            return 6;
        }

        if (now.year() - year === 1 && (now.month()+1) < 6) {
            return 6 - (now.month()+1);
        }
    }
    return null;
}

export function defterUnitIsPage(identifier) {
    return [EntegratorIdentifiers.SMART,
            EntegratorIdentifiers.KOLAYSOFT,
            EntegratorIdentifiers.MBT].includes(identifier);
}

export function defterUnitName(identifier) {
    return ([EntegratorIdentifiers.SMART,
             EntegratorIdentifiers.KOLAYSOFT,
             EntegratorIdentifiers.MBT].includes(identifier) ? "Sayfa" : "Alan");
}

export function defterUnitNameShort(identifier) {
    return ([EntegratorIdentifiers.SMART,
            EntegratorIdentifiers.KOLAYSOFT,
            EntegratorIdentifiers.MBT].includes(identifier) ? "Adet" : "MB");
}

export function showReportSettingButton(identifier, vknTckn) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(identifier) &&
        "14602103670" === vknTckn;
}


export function connectorPaymentExceptionUser(identifier, vknTckn, exceptionCustomerVknTckns) {
    return exceptionCustomerVknTckns.includes(vknTckn) && [EntegratorIdentifiers.KOLAYSOFT].includes(identifier);
}

export function showCreditDistributeButton(identifier, currentUser) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT].includes(identifier)
        && currentUser.isDistributor && currentUser.workType===3 && (currentUser.vknTckn === "40079187332" || currentUser.parentCustomerId===32585);
}

export function showOnlySmart(identifier){
    return EntegratorIdentifiers.SMART === identifier;
}

export function showVatStateReport(identifier, parentCustomerId){
    return (EntegratorIdentifiers.KOLAYSOFT === identifier && [5925, 15829, 16103,46486,28839,30735].includes(parentCustomerId));
}

export function showVatSGKDEPO(identifier, parentCustomerId){
    return (EntegratorIdentifiers.KOLAYSOFT === identifier && [5925, 15829, 16103,46486,28839,30735].includes(parentCustomerId));
}
export function showETicaret(identifier, parentCustomerId){
    return (([EntegratorIdentifiers.KOLAYSOFT].includes(identifier) && ![5925, 15829, 16103,46486,28839,30735].includes(parentCustomerId)) ||
            [EntegratorIdentifiers.SMART].includes(identifier) ||
            [EntegratorIdentifiers.MBT].includes(identifier)) && "eczacikart" !== VirtualHost.conf.resourcePrefix;
}

export function showUnsignedEDefterApplication(identifier) {
    return [EntegratorIdentifiers.KOLAYSOFT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.MBT,EntegratorIdentifiers.DEVATEK].includes(identifier);
}

export function showKolaysoftPos(parentCustomerId,vuk507PosApplicationUrl){
    return [10941,12359,6951,104088].includes(parentCustomerId) && vuk507PosApplicationUrl;
}

export function showPosPayment(parentCustomerId,vuk507PosApplicationUrl){
    return [10941,12359,6951,104088,5925,15829,16103,46486,28839,30735].includes(parentCustomerId) && vuk507PosApplicationUrl;
}

export function checkIade(invoiceTypeCode){
    return (invoiceTypeCode === 'TEVKIFATIADE' || invoiceTypeCode === 'IADE');
}